/**
 * « Utilisateurs bloqués » (profil) — migration 0604. Liste des personnes que
 * j'ai bloquées, avec « Débloquer ».
 */

import { AvatarCircle } from '@/components/avatar-circle';
import { useBlockedUsers, useUnblockUser } from '@/lib/safety/user-safety';

export function BlockedUsersPanel() {
  const blocked = useBlockedUsers();
  const unblock = useUnblockUser();

  if (blocked.isLoading) return <p className="text-ink-400 text-sm">Chargement…</p>;
  if (blocked.isError)
    return <p className="text-sm text-red-600">Impossible de charger la liste.</p>;

  const users = blocked.data ?? [];
  if (users.length === 0) {
    return (
      <p className="text-ink-500 text-sm">
        Tu n’as bloqué personne. Pour bloquer ou signaler quelqu’un, ouvre une discussion avec lui
        ou ta liste de camarades.
      </p>
    );
  }

  return (
    <ul className="space-y-2">
      {users.map((u) => (
        <li key={u.userId} className="flex items-center gap-3">
          <AvatarCircle name={u.displayName} src={u.avatarUrl} size="sm" />
          <span className="text-ink-900 min-w-0 flex-1 truncate text-sm font-semibold">
            {u.displayName}
          </span>
          <button
            type="button"
            disabled={unblock.isPending && unblock.variables === u.userId}
            onClick={() => unblock.mutate(u.userId)}
            className="border-ink-200 text-ink-700 min-h-[2.75rem] shrink-0 rounded-xl border bg-white px-4 text-sm font-semibold active:scale-[0.98] disabled:opacity-50"
          >
            Débloquer
          </button>
        </li>
      ))}
      {unblock.isError && (
        <li role="alert" className="text-sm text-red-600">
          {unblock.error.message}
        </li>
      )}
    </ul>
  );
}
